module.exports = __webpack_public_path__ + "img/osa.f0ef6c83.png";